<script lang='ts'>
import { reactive, defineComponent } from '@vue/composition-api';

interface IProps {
    label: string;
    rules: [];
    errorMessages: [];
    value: any;
}

const AppPasswordField = defineComponent({
    name: 'AppPasswordField',
    props: { label: String, rules: Array, value: String, errorMessages: Array },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props, ctx) {
        const state = reactive({
            showPassword: false,
        });

        const onInput = (value: string) => {
            ctx.emit('input', value);
        };

        return {
            state,
            onInput,
        };
    },
});

export default AppPasswordField;
</script>

<template>
  <v-text-field
    :append-icon="state.showPassword ? '$falEyeSlash' : '$falEye'"                   
    :type="state.showPassword ? 'text' : 'password'"
    :rules="rules"
    :error-messages="errorMessages"
    :label="label"
    :value="value"
    @input="onInput"
    @click:append="state.showPassword = !state.showPassword"
  />
</template>

<style lang='scss' scoped></style>